import { FaPlus } from "react-icons/fa6";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { RxCross2 } from "react-icons/rx";

const FAQData = [
    {
        questNo: 1,
        quest: "Will switching to this all-in-one checkout plugin disrupt my current WooCommerce setup?",
        response:
            "Not at all. KwikCheckout is built to integrate smoothly with your existing stack — without breaking anything. Most brands go live in few minutes, with zero disruption to sales.",
    },
    {
        questNo: 2,
        quest: "Will it interfere with our existing payment gateway or plugins?",
        response:
            "Yes! Kwik Engage seamlessly integrates with Shopify, custom stores, and mobile apps.",
    },
    {
        questNo: 3,
        quest: "Is this secure and scalable for peak traffic?",
        response:
            "It works across WhatsApp, Email, SMS, Instagram, Facebook, and on-site pop-ups.",
    },
    {

        questNo: 4,
        quest: "Will I lose control over customization and design?",
        response:
            "We utilize advanced fingerprinting, combined with phone-first OTP authentication, to instantly recognize visitors—even without traditional logins.",
    },

];


const SectionSix = () => {
    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    const isMobile = useMediaQuery({ maxWidth: 768 });

    return (
        <div style={{ color: "#fff" }}>

         
            <div className='sec-six-container'>

                <div className='sec-six-row'>
                    <div className='sec-six-content'>
                        <h1 className='sec-six-heading'>Launch Fast, Scale Faster</h1>
                        <div className='sec-six-subtext'>
                            <p>Zero tech bottlenecks</p>
                            <span>|</span>
                            <p>100% conversion-ready</p>
                        </div>
                    </div>

                    <button onClick={scrollToTop} className='sec-six-cta-btn'>
                        Book a demo
                    </button>
                </div>

                <div className="section-six-Woo">
                    <div
                        style={{
                            minHeight: "70vh",
                            padding: "0",
                            boxSizing: "border-box"
                        }}
                    >
                        <div
                            style={{
                                maxWidth: "700px",
                                margin: isMobile ? "0 20px " : "0 auto",

                            }}
                        >
                            <h1
                                style={{
                                    textAlign: isMobile ? 'center' : "left",
                                    color: "#000",
                                    fontSize: "clamp(28px, 3vw, 56px)",
                                    fontWeight: 400,
                                    marginBottom: "36px",
                                    fontFamily: "Inter, Arial, sans-serif"
                                }}
                            >
                                FAQs
                            </h1>
                            <div>
                                {FAQData.map((faq, idx) => (
                                    <div
                                        key={faq.questNo}
                                        style={{
                                            background: "#F8F8F8",
                                            borderRadius: "7px",
                                            boxShadow: "0 1px 2px 0 rgba(16,24,40,0.04)",
                                            marginBottom: "16px",
                                            overflow: "hidden",
                                            border: "1px solid #eee"
                                        }}
                                    >
                                        <button
                                            style={{
                                                width: "100%",
                                                background: "transparent",
                                                border: "none",
                                                outline: "none",
                                                padding: 0,
                                                cursor: "pointer",
                                                textAlign: "left"
                                            }}
                                            onClick={() => toggleAccordion(idx)}
                                            aria-expanded={activeIndex === idx}
                                            aria-controls={`faq-response-${idx}`}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    fontSize: "clamp(12px, 3vw, 18px)",
                                                    fontWeight: 500,
                                                    color: "#111",
                                                    padding: "18px 20px",
                                                    fontFamily: "Inter, Arial, sans-serif"
                                                }}
                                            >
                                                <span>{faq.quest}</span>
                                                <span
                                                    style={{
                                                        marginLeft: "20px",
                                                        color: "#222",
                                                        fontSize: "clamp(12px, 3vw, 18px)",
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    {activeIndex === idx ? <RxCross2 /> : <FaPlus />}
                                                </span>
                                            </div>
                                        </button>
                                        <div
                                            id={`faq-response-${idx}`}
                                            style={{
                                                maxHeight: activeIndex === idx ? "200px" : "0",
                                                overflow: "hidden",
                                                background: "#fff",
                                                transition: "max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
                                                padding: activeIndex === idx ? "0 20px 16px 20px" : "0 20px",
                                                opacity: activeIndex === idx ? 1 : 0,
                                                fontSize: "clamp(12px, 3vw, 18px)",
                                                color: "#333"
                                            }}
                                        >
                                            {activeIndex === idx && (
                                                <div style={{ paddingTop: "4px", paddingBottom: "2px" }}>
                                                    {faq.response}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    );
};

export default SectionSix;
